import { createContext } from "react";
import IAuthContext from "../../types/Auth";
// import { AlertColor } from "@mui/material/Alert";

const defaultState: IAuthContext = {
  isAuthenticated: false,
  isAuthorized: false,
  roleType: "",
  roleDetails: [],
  authId: null,
  notificationCount: 0,
  customerNotifications: [],
  filingNotifications: [],
  customerNotificationsWorkFlow: [],
  loading: false,
  isPortalAuthenticated: false,
  allNotificationCount: null,
};

const AuthContext = createContext<IAuthContext>(defaultState);

export default AuthContext;
